import React, { useEffect, useState } from "react";
export default function ImageS3({ largeScreen, photo, ...props }) {
  const [imageSource, setImageSource] = useState();
  const [imageLoaded, setImageLoaded] = useState(true);

  // const setNull = () => {
  //   setImageSource(null);
  //   setImageLoaded(false);
  // };

  // useEffect(() => {
  //   fetch(photo)
  //     .then((data) => {
  //       data.status !== 200 ? setNull() : setImageSource(photo);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, []);

  return (
    <>
      {photo ? (
        <img
          alt=""
          style={{
            height: props.height ? props.height : "100%",
            width: props.width ? props.width : "100%",
            objectFit: `${largeScreen ? "" : "cover"}`,
          }}
          src={photo}
          {...props}
          onError={() => setImageLoaded(true)}
        />
      ) : (
        <div
          className={`card-img-top h-${
            props.height ? props.height : "225px"
          } w-${props.width ? props.width : ""}`}
          style={{
            background: "#f89534",
            height: props.height ? props.height : "225px",
            width: props.width ? props.width : "100%",
            // borderTopLeftRadius:  'calc(0.42rem - 1px)',
            // borderTopRightRadius: 'calc(0.42rem - 1px)',
            borderRadius: props.borderRadius ? props.borderRadius : "",
            display: imageSource && !imageLoaded && "none",
            maxHeight: props.height && props.height,
            maxWidth: props.width && props.width,
          }}
        />
      )}
    </>
  );
}
